import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from "axios";
import '../Admin/Admin.css';
import Header from "../Home/Header";
import DialogBox from "../Home/DialogBox";
import { MdDelete } from 'react-icons/md';

function AttendanceTable() {
  const [attendance, setAttendance] = useState([]);
    const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    memberId: "",
    memberName: "",
     branchCode: "",
    email: "",
    startDate: "",
    endDate: ""
  });

  const [dialog, setDialog] = useState({
    show: false,
    title: "Confirm Delete",
    message: "",
    type: "confirm",
    onConfirm: null,
  });

      useEffect(() => {
        const role = sessionStorage.getItem("userRole");
        if (!role) navigate("/");
      }, [navigate]);

  // Replace this in your render part, before the return JSX
  // Filtered attendance
const filteredAttendance = attendance.filter((a) => {
  const idMatch =
    !filters.memberId ||
    (a.memberId || "").toLowerCase() === filters.memberId.toLowerCase();

  const nameMatch =
    (a.memberName || "")
      .toLowerCase()
      .includes(filters.memberName.toLowerCase());

  const emailMatch =
    (a.email || "")
      .toLowerCase()
      .includes(filters.email.toLowerCase());

  const branchMatch =
    !filters.branchCode ||
    (a.branchCode || "")
      .toLowerCase()
      .includes(filters.branchCode.toLowerCase());

  const typeMatch = filters.membershipType
    ? (a.membershipType || "").toLowerCase() ===
      filters.membershipType.toLowerCase()
    : true;

  const startDateMatch = filters.startDate
    ? new Date(a.date) >= new Date(filters.startDate)
    : true;

  const endDateMatch = filters.endDate
    ? new Date(a.date) <= new Date(filters.endDate)
    : true;

  return (
    idMatch &&
    nameMatch &&
    emailMatch &&
    branchMatch &&
    typeMatch &&
    startDateMatch &&
    endDateMatch
  );
});

  // ✅ Add this line
  const attendanceCount = filteredAttendance.length;



  // Fetch attendance with current filters
  const fetchAttendance = async () => {
    setLoading(true);
    try {
      const params = {
        memberId: filters.memberId || undefined,
        memberName: filters.memberName || undefined,
        email: filters.email || undefined,
        startDate: filters.startDate || undefined,
        endDate: filters.endDate || undefined
      };

      const res = await axios.get(
        "https://gym-invoice-back.onrender.com/api/attendance",
        { params }
      );
      const sorted = res.data.sort((a, b) => {
        const dateA = new Date(`${a.date} ${a.time}`);
        const dateB = new Date(`${b.date} ${b.time}`);
        return dateB - dateA; // latest first
      });
      setAttendance(sorted);

    } catch (error) {
      console.error("Error fetching attendance:", error);
      alert("Failed to fetch attendance");
    } finally {
      setLoading(false);
    }
  };

  // Auto fetch whenever filters change
  useEffect(() => {
    fetchAttendance();
  }, [filters]);

  const handleDelete = (id) => {
    setDialog({
      show: true,
      title: "Confirm Delete",
      message: "Are you sure you want to delete this attendance record?",
      type: "confirm",
      onConfirm: async () => {
        try {
          await axios.delete(`https://gym-invoice-back.onrender.com/api/attendance/delete/${id}`);
          alert("Attendance deleted successfully!");
          fetchAttendance();
        } catch (error) {
          console.error("Failed to delete attendance:", error);
          alert("Failed to delete attendance record.");
        }
      }
    });
  };

  const formatTimeToAMPM = (time) => {
    if (!time) return "";

    const [hour, minute] = time.split(":");
    const date = new Date();
    date.setHours(hour, minute);

    let h = date.getHours();
    const m = date.getMinutes().toString().padStart(2, "0");

    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;

    // Add leading zero to hour
    const hourFormatted = h.toString().padStart(2, "0");

    return `${hourFormatted}:${m} ${ampm}`;
  };


  return (
    <div className="container">
      <Header />
      <div className="payment-container">
        <h2>Attendance Report</h2>

        {/* Structured Search Section */}
        <div className="payment-card">
          <h2>🔍 Search Filters</h2>
           <div className="filter-row">

          <div className="filter-item">
            <label>Branch Code</label>
            <select
              className="duration-select"
              value={filters.branchCode}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  branchCode: e.target.value
                })
              }
            >
              <option value="">ALL BRANCHES</option>
               <option value="KB">KB - Kesbewa</option>
                         <option value="WB">WB - Werahera</option>
            </select>
          </div>
            </div>

          <div className="filter-row">
            <div className="filter-item">
              <label>Member ID</label>
              <input
                placeholder="Member ID"
                value={filters.memberId}
                onChange={(e) => setFilters({ ...filters, memberId: e.target.value })}
              />
            </div>

            <div className="filter-item">
              <label>Member Name</label>
              <input
                placeholder="Name"
                value={filters.memberName}
                onChange={(e) => setFilters({ ...filters, memberName: e.target.value })}
              />
            </div>


          </div>

          <div className="filter-row">
            <div className="filter-item">
              <label>Start Date</label>
              <input
                type="date"
                value={filters.startDate}
                onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
              />
            </div>

            <div className="filter-item">
              <label>End Date</label>
              <input
                type="date"
                value={filters.endDate}
                onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
              />
            </div>

           {filters.startDate && filters.endDate && (
             <h3 style={{ marginTop: "15px" }}>
               Total Attendance: <strong>{attendanceCount}</strong>
             </h3>
           )}


          </div>
        </div>

        {/* Table */}
        {loading ? (
          <p>Loading...</p>
        ) : (
          <table className="payment-table">
            <thead>
              <tr>
              <th>Branch Code</th>
                <th>Member ID</th>
                <th>Name</th>
                <th>Date</th>
                <th>Time</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
             {filteredAttendance.length > 0 ? (
               filteredAttendance.map((record) => (
                 <tr key={record.id}>
                 <td>{record.branchCode}</td>
                   <td>{record.memberId}</td>
                   <td>{record.memberName}</td>
                   <td>
                     {record.date
                       ? new Date(record.date).toLocaleDateString("en-GB") // dd/mm/yyyy format
                       : ""}
                   </td>

                   <td>{formatTimeToAMPM(record.time)}</td>

                   <td>
                     <div className="table-action-buttons">
                       <button
                         onClick={() => handleDelete(record.id)}
                         className="action-btn delete-btn"
                       >
                         <MdDelete size={20} /> Delete
                       </button>
                     </div>
                   </td>
                 </tr>
               ))
             ) : (
               <tr>
                 <td colSpan="7">No records found.</td>
               </tr>
             )}

            </tbody>
          </table>
        )}
      </div>

      <DialogBox dialog={dialog} setDialog={setDialog} />
    </div>
  );
}

export default AttendanceTable;
